<template>
  <div>
    <VCard title="Ticket Analysis 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'ticket-dashboard',
  },  
})
</script>
